import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-log-viewer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './log-viewer.component.html',
  styleUrls: ['./log-viewer.component.scss']
})
export class LogViewerComponent implements OnChanges {
  @Input() logContent: string = '';
  logLines: SafeHtml[] = [];

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    if (this.logContent) {
      const parsedContent = this.parseAnsiColors(this.logContent);
      this.logLines = parsedContent.split('\n').map(line => this.sanitizer.bypassSecurityTrustHtml(line));
    }
  }

  private parseAnsiColors(text: string): string {
    const ansiToHtml: { [key: string]: string } = {
      '0': 'color: #d3d7cf !important;',
      '30': 'color: #2e3436 !important;',
      '31': 'color: #cc0000 !important;',
      '32': 'color: #4e9a06 !important;',
      '33': 'color: #f57900 !important;',
      '34': 'color: #729fcf !important;',
      '35': 'color: #ad7fa8 !important;',
      '36': 'color: #06989a !important;',
      '37': 'color: #eeeeec !important;',
      '90': 'color: #888a85 !important;',

      '0;31': 'color: #cc0000 !important;',
      '0;32': 'color: #4e9a06 !important;',
      '0;33': 'color: #f57900 !important;',
      '0;34': 'color: #729fcf !important;',
      '0;35': 'color: #ad7fa8 !important;',
      '0;36': 'color: #06989a !important;',
      '0;37': 'color: #eeeeec !important;',
    };

    let result = text;
    const regex = /\[(\d+;?\d*)m/g;
    let match;

    while ((match = regex.exec(text)) !== null) {
      const fullMatch = match[0]; // e.g., '[0;34m'
      const code = match[1];      // e.g., '0;34'
      
      const styleSheet = ansiToHtml[code];

      if (styleSheet === 'ansi-reset') {
        result = result.replace(fullMatch, '</span>');
      } else if (styleSheet) {
        result = result.replace(fullMatch, `<span style="${styleSheet}">`);
      }
    }
    return result;
  }
}